import { createContext, useContext, type ReactNode } from 'react';

/**
 * Wave 4 (D-507, spec §6): how a user wants lists shown — `table`, `card`, or `auto` (cards below 768 px, a table
 * above). A global preference; a hub lens may override it in the personal layout. Without a provider lists are tables.
 */
export type ListMode = 'table' | 'card' | 'auto';

const ListModeContext = createContext<ListMode>('table');

export function ListModeProvider({ mode, children }: { mode: ListMode; children?: ReactNode }) {
  return <ListModeContext.Provider value={mode}>{children}</ListModeContext.Provider>;
}

export function useListMode(): ListMode {
  return useContext(ListModeContext);
}

/** Below this width `auto` shows cards. */
export const LIST_MODE_AUTO_QUERY = '(max-width: 767px)';

/** The grid layout a list mode opens in; `narrow` is whether `LIST_MODE_AUTO_QUERY` matches. */
export function layoutForListMode(mode: ListMode, narrow: boolean): 'table' | 'cards' {
  if (mode === 'card') return 'cards';
  if (mode === 'auto') return narrow ? 'cards' : 'table';
  return 'table';
}
